(() => {
  const applyStoryStyle = () => {
    const frame = document.getElementById('pp-dreamland-frame');
    if (!frame || frame.dataset.ppStyled || !frame.hasAttribute('srcdoc')) return;
    frame.dataset.ppStyled = 'true';
    const source = frame.getAttribute('srcdoc');
    const computed = getComputedStyle(document.body);
    const bodyFont = computed.getPropertyValue('--font-body--family').trim() || 'sans-serif';
    const headingFont = computed.getPropertyValue('--font-heading--family').trim() || 'serif';
    let faces = '';
    for (const sheet of document.styleSheets) {
      try {
        for (const rule of sheet.cssRules) {
          if (rule.type === CSSRule.FONT_FACE_RULE) faces += rule.cssText;
        }
      } catch {}
    }
    const style = `<style id="pp-story-brand">${faces}body{background:#fff3d8;color:#172f31;font-family:${bodyFont}}h1,h2,h3,.book{font-family:${headingFont}}header{border-color:#172f31}header a,.eyebrow,h1 em,.stars{color:#a63f24}header span,.welcome>p:last-of-type,.hint,.privacy,.world small{color:#555347}input,select{background:#fff;color:#172f31;border-color:#8e845f;font-family:${bodyFont}}input::placeholder{color:#555347}.primary{background:#a63f24;color:#fff3d8;border-radius:3px;box-shadow:3px 3px #172f31}.secondary{background:#f7e7bd;color:#172f31;border-color:#8e845f;border-radius:3px;box-shadow:3px 3px #172f31}.world{background:#f7e7bd;border-color:#172f31;color:#172f31}.world:has(input:checked){background:#e7ead6;border-color:#43664d;box-shadow:inset 0 0 0 1px #43664d}.book{background:#fff3d8;color:#172f31;border:2px solid #172f31;border-radius:3px}.book-top{color:#555347}.remove{color:#a63f24}button,input,select{font-family:${bodyFont}}button:focus-visible,input:focus-visible,select:focus-visible{outline:3px solid #0d5358;outline-offset:3px}</style>`;
    frame.setAttribute('srcdoc', source.replace('</head>', style + '</head>'));
    frame.style.background = '#fff3d8';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyStoryStyle, {once: true});
  else applyStoryStyle();
  document.addEventListener('shopify:section:load', applyStoryStyle);
})();

